import { Component, OnInit } from '@angular/core';
import { TagService } from '../shared/services/tag.service';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
    selector: 'saved-tags',
    templateUrl: './saved-tags.component.html'
})

export class SavedTagsComponent implements OnInit {

    constructor(
        private tagService: TagService,
        private router: Router,
        private route: ActivatedRoute
        ) {
    }

    dataLoaded: boolean;

    ngOnInit() {
        let ids;
        this.route.params.forEach((params: Params) => {
            ids = params['ids'].split(",").map(Number);
        });

        if(ids.length){
            this.tagService.setSelectedTagCategories(ids).then(response => {
                this.router.navigate(['/courses/tagged']);
            });
        } else {
            this.router.navigate(['/tag-list']);
        }
    }

}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/saved-tags/saved-tags.component.ts